<script>
import { useAlert } from 'dashboard/composables';
import { mapActions } from 'vuex';

export default{
  name: "ConfirmClearModal",
}
</script>

<template>
  <div class="fixed inset-0 flex items-center justify-center bg-slate-800/80 z-50">
    <div class="bg-white dark:bg-slate-800 rounded-lg p-6 shadow-lg w-96">
      <!-- header -->
       <div class="flex items-center mb-4 justify-between">
        <h1 class="text-xl font-bold text-red-500">Clear Confirmation</h1>
        <woot-button variant="clear" color-scheme="alert" icon="dismiss" @click="$emit('close')"/>
       </div>

      <p>Are you sure you want to clear all winners?</p>

      <!-- Action buttons -->
       <div class="flex justify-end gap-4">
        <woot-button color-scheme="secondary" @click="$emit('close')">Cancel</woot-button>
        <woot-button color-scheme="alert" @click="$emit('confirm')">Confirm</woot-button>
       </div>
    </div>
  </div>
</template>